/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IPollManagerACL",
                name: "in_managerACL",
                type: "address",
            },
            {
                internalType: "contract IGaslessVoter",
                name: "in_gaslessVoter",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "Close_NotActive",
        type: "error",
    },
    {
        inputs: [],
        name: "Close_NotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "Close_NotOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "Create_AlreadyExists",
        type: "error",
    },
    {
        inputs: [],
        name: "Create_InvalidACL",
        type: "error",
    },
    {
        inputs: [],
        name: "Create_NoChoices",
        type: "error",
    },
    {
        inputs: [],
        name: "Create_NotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "Create_TooManyChoices",
        type: "error",
    },
    {
        inputs: [],
        name: "Destroy_NotFound",
        type: "error",
    },
    {
        inputs: [],
        name: "Destroy_NotOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "Poll_NotActive",
        type: "error",
    },
    {
        inputs: [],
        name: "Poll_NotPublishingVoters",
        type: "error",
    },
    {
        inputs: [],
        name: "Poll_NotPublishingVotes",
        type: "error",
    },
    {
        inputs: [],
        name: "Poll_StillActive",
        type: "error",
    },
    {
        inputs: [],
        name: "Vote_NotActive",
        type: "error",
    },
    {
        inputs: [],
        name: "Vote_NotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "Vote_UnknownChoice",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "topChoice",
                type: "uint256",
            },
        ],
        name: "ProposalClosed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        inputs: [],
        name: "GASLESS_VOTER",
        outputs: [
            {
                internalType: "contract IGaslessVoter",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "OWNERS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "in_voter",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "uint256",
                name: "out_weight",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "close",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "numChoices",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "flags",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "closeTimestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "contract IPollACL",
                        name: "acl",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "metadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct PollManager.ProposalParams",
                name: "in_params",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "in_aclData",
                type: "bytes",
            },
        ],
        name: "create",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "numChoices",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "flags",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "closeTimestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "contract IPollACL",
                        name: "acl",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "metadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct PollManager.ProposalParams",
                name: "in_params",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "in_aclData",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "in_owner",
                type: "address",
            },
        ],
        name: "createFor",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "destroy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getACL",
        outputs: [
            {
                internalType: "contract IPollManagerACL",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "in_offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "in_limit",
                type: "uint256",
            },
        ],
        name: "getActiveProposals",
        outputs: [
            {
                internalType: "uint256",
                name: "out_count",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "topChoice",
                                type: "uint8",
                            },
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "numChoices",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint8",
                                        name: "flags",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint32",
                                        name: "closeTimestamp",
                                        type: "uint32",
                                    },
                                    {
                                        internalType: "contract IPollACL",
                                        name: "acl",
                                        type: "address",
                                    },
                                    {
                                        internalType: "bytes",
                                        name: "metadata",
                                        type: "bytes",
                                    },
                                ],
                                internalType: "struct PollManager.ProposalParams",
                                name: "params",
                                type: "tuple",
                            },
                        ],
                        internalType: "struct PollManager.Proposal",
                        name: "proposal",
                        type: "tuple",
                    },
                ],
                internalType: "struct PollManager.ProposalWithId[]",
                name: "out_proposals",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "in_offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "in_limit",
                type: "uint256",
            },
        ],
        name: "getPastProposals",
        outputs: [
            {
                internalType: "uint256",
                name: "out_count",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "topChoice",
                                type: "uint8",
                            },
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "numChoices",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint8",
                                        name: "flags",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint32",
                                        name: "closeTimestamp",
                                        type: "uint32",
                                    },
                                    {
                                        internalType: "contract IPollACL",
                                        name: "acl",
                                        type: "address",
                                    },
                                    {
                                        internalType: "bytes",
                                        name: "metadata",
                                        type: "bytes",
                                    },
                                ],
                                internalType: "struct PollManager.ProposalParams",
                                name: "params",
                                type: "tuple",
                            },
                        ],
                        internalType: "struct PollManager.Proposal",
                        name: "proposal",
                        type: "tuple",
                    },
                ],
                internalType: "struct PollManager.ProposalWithId[]",
                name: "out_proposals",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "proposalId",
                type: "bytes32",
            },
        ],
        name: "getPollACL",
        outputs: [
            {
                internalType: "contract IPollACL",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "getProposalById",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "id",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "owner",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "topChoice",
                                type: "uint8",
                            },
                            {
                                components: [
                                    {
                                        internalType: "uint8",
                                        name: "numChoices",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint8",
                                        name: "flags",
                                        type: "uint8",
                                    },
                                    {
                                        internalType: "uint32",
                                        name: "closeTimestamp",
                                        type: "uint32",
                                    },
                                    {
                                        internalType: "contract IPollACL",
                                        name: "acl",
                                        type: "address",
                                    },
                                    {
                                        internalType: "bytes",
                                        name: "metadata",
                                        type: "bytes",
                                    },
                                ],
                                internalType: "struct PollManager.ProposalParams",
                                name: "params",
                                type: "tuple",
                            },
                        ],
                        internalType: "struct PollManager.Proposal",
                        name: "proposal",
                        type: "tuple",
                    },
                ],
                internalType: "struct PollManager.ProposalWithId",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "numChoices",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "flags",
                        type: "uint8",
                    },
                    {
                        internalType: "uint32",
                        name: "closeTimestamp",
                        type: "uint32",
                    },
                    {
                        internalType: "contract IPollACL",
                        name: "acl",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "metadata",
                        type: "bytes",
                    },
                ],
                internalType: "struct PollManager.ProposalParams",
                name: "in_params",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "in_aclData",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "in_owner",
                type: "address",
            },
        ],
        name: "getProposalId",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "getVoteCounts",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "in_offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "in_limit",
                type: "uint256",
            },
        ],
        name: "getVoters",
        outputs: [
            {
                internalType: "uint256",
                name: "out_count",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "out_voters",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "in_offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "in_limit",
                type: "uint256",
            },
        ],
        name: "getVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "out_count",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "out_voters",
                type: "address[]",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "weight",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "choice",
                        type: "uint8",
                    },
                ],
                internalType: "struct PollManager.Choice[]",
                name: "out_choices",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "in_voter",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "in_choiceId",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "proxy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "in_choiceId",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "vote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class PollManager__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(in_managerACL, in_gaslessVoter, overrides) {
        return super.getDeployTransaction(in_managerACL, in_gaslessVoter, overrides || {});
    }
    deploy(in_managerACL, in_gaslessVoter, overrides) {
        return super.deploy(in_managerACL, in_gaslessVoter, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
PollManager__factory.bytecode = _bytecode;
PollManager__factory.abi = _abi;
//# sourceMappingURL=PollManager__factory.js.map